import React from 'react';
import ReactDOM from 'react-dom/client';
import WwwApp from './WwwApp.jsx';
import '../../shared/base.css';
import './www.css';

// No router. It is one page, and the two links that leave it are whole other
// origins - the admin site and a display.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <WwwApp />
  </React.StrictMode>
);
